import './BlogContent/register'
import './BlogHero/register'
import './BlogIframe/register'
import './BlogImage/register'
import './BlogVideo/register'
